import React, { useState } from "react";
import { Typography, Space } from "antd";
import { RightOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const PortalStyleDirect = ({ modules, onNavigate }) => {
    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gridTemplateRows: "repeat(2, 1fr)",
                gap: "16px",
                height: "100%",
                padding: "8px",
            }}
        >
            {modules.map((mod) => (
                <div
                    key={mod.key}
                    style={{
                        background: "#fff",
                        borderRadius: "16px",
                        border: `1px solid #f0f0f0`,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "row", // Split Layout
                        transition: "all 0.3s ease",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.02)",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.08)";
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.borderColor = mod.borderColor;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.02)";
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.borderColor = "#f0f0f0";
                    }}
                >
                    {/* Left Column: Identity */}
                    <div
                        style={{
                            width: "35%",
                            background: mod.color, // Full color column
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "16px",
                            borderRight: `1px solid ${mod.borderColor}20`,
                        }}
                    >
                        <div style={{ marginBottom: "12px", color: mod.borderColor, fontSize: "28px" }}>{mod.icon}</div>
                        <Title level={5} style={{ margin: 0, textAlign: "center", fontSize: "14px", fontWeight: 700, color: "#262626" }}>
                            {mod.title.split(" ")[0]} {/* Simplified Title */}
                        </Title>
                    </div>

                    {/* Right Column: Actions (Directly Visible) */}
                    <div
                        style={{
                            flex: 1,
                            padding: "12px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            gap: "8px",
                        }}
                    >
                        {/* Only show top 3 items to fit */}
                        {mod.items.slice(0, 3).map((item, idx) => (
                            <div
                                key={idx}
                                onClick={() => onNavigate(item.path)}
                                style={{
                                    padding: "6px 10px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    fontSize: "13px",
                                    color: "#595959",
                                    transition: "background 0.2s",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                            >
                                <span style={{ color: mod.borderColor, fontSize: "14px" }}>{item.icon}</span>
                                <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.label}</span>
                            </div>
                        ))}

                        {/* More hint if more than 3 */}
                        {mod.items.length > 3 && (
                            <div
                                style={{
                                    padding: "4px 10px",
                                    fontSize: "12px",
                                    color: "#8c8c8c",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    cursor: "default",
                                }}
                            >
                                <RightOutlined style={{ fontSize: "10px" }} /> 一般不用点更多
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PortalStyleDirect;
